import { C43MediaGalleryItemProps } from './C43MediaGalleryItem.types';
import { MediaItem } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function GetMediaGalleryItemModel(
  props?: Pick<C43MediaGalleryItemProps, 'fields'>
): MediaItem {
  const { renderText, renderRichText, renderImage } = useConditionalRendering();
  const { fields } = props || {};
  const slide: MediaItem = {
    image: renderImage(fields?.Image),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    videoId: fields?.VideoID?.value,
    videoIdField: renderText(fields?.VideoID),
  };
  return slide;
}
